<template>
<b-container fluid>
    <b-row>
        <b-col lg="8">
            <card>
                 <MediaTable ref="mediaTable" @selectItem="onSelectItem" @newItem="onNewItem" />
            </card>
        </b-col>
        <b-col>
             <InfoCard v-if="action == ''"></InfoCard>
            <MediaEditForm v-else-if="action == 'new'" :media="item"></MediaEditForm>
            <MediaEditForm v-else-if="action == 'item'" :editing="true" :media="item"></MediaEditForm>

        </b-col>
    </b-row>
</b-container>

</template>

<script>

import MediaTable from '@/components/Content/Media/MediaTable'
import MediaEditForm from '@/components/Content/Media/MediaEditForm'

export default {
    components: {
        MediaTable,
        MediaEditForm
    }, 
    data() {
        return {
            action: "",
            item: null        
        }
    },
    methods: {
        onNewItem() {
            this.item = {
                mediaId: null,
                name: null,
                mediaType: "image",
                url: null,
                mediaUploadToken: null
            };
            this.action = "new"
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"
        }
    },
    watch: {
        item(){
            if(this.item == null && this.action == "item"){
                this.action = "";
            }
        }
    }
}
</script>
